import { Box, Typography } from '@mui/material';
import { useSettings } from 'contexts/Settings/Settings';
import * as setup from 'setup';
import FunnelInput from '../FunnelInput/FunnelInput';
import FunnelZoomButton from '../FunnelZoomButton/FunnelZoomButton';
import { FunnelStepContainer } from './FunnelStep.styles';

export default function FunnelStep({
    disableBounds,
    disableInputs,
    disableZooms,
    hide,
    hideBody,
    highlight,
    rangeMode,
    step,
    zoomable,
    zoomed,
    onChange,
    onZoom,
}: FunnelStepProps) {

    const settings = useSettings();

    const stepSetup = setup.game.steps[step.index];

    return (
        <FunnelStepContainer $hide={hide} $index={step.index}>
            {(zoomable || zoomed) && (
                <Box
                    sx={{
                        position: 'absolute',
                        left: -15,
                        top: 'calc(50% - 15px)'
                    }}>
                    <FunnelZoomButton
                        disabled={disableZooms}
                        type={zoomable ? 'in' : 'out'}
                        onClick={type => onZoom?.(step, type)}
                    />
                </Box>
            )}
            <Typography
                align="center"
                color={setup.colors.black}
                variant="montserrat418"
                sx={{
                    bgcolor: 'rgba(249, 193, 50, 0.2)',
                    // Render as a full-width block so `align="center"` centers the
                    // step-name text across the card, directly over the centered
                    // estimate-input row below (the custom `montserrat418` variant
                    // otherwise maps to an inline span that hugs the text at the left).
                    display: 'block',
                    padding: 1,
                    marginBottom: 0
                }}>
                {stepSetup.name}
            </Typography>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    gap: 0.25,
                    justifyContent: 'center',
                    padding: 0.25,
                    visibility: (hideBody && !settings.debugFunnel) ? 'hidden' : undefined
                }}>
                {(rangeMode || settings.debugFunnel) && <>
                    <Typography variant="montserrat412">
                        MIN
                    </Typography>
                    <FunnelInput
                        disabled={disableInputs}
                        max={step.max}
                        placeholder={`e.g. ${step.placeholder.toLocaleString()}`}
                        value={step.min}
                        onChange={value => onChange({ min: value })}
                    />
                    <Typography variant="montserrat412">
                        MAX
                    </Typography>
                </>}
                <FunnelInput
                    autoFocus={highlight}
                    disabled={disableInputs}
                    max={disableBounds ? undefined : step.bounds.max}
                    min={disableBounds ? undefined : step.bounds.min}
                    placeholder={`e.g. ${step.placeholder.toLocaleString()}`}
                    value={disableBounds && !step.max ? undefined : step.max}
                    onChange={value => onChange({ max: value })}
                />
                <Typography variant="montserrat412" sx={{
                    textTransform: 'uppercase'
                }}>
                    {stepSetup.operator}
                </Typography>
            </Box>
            {settings.debugFunnel && (
                <Typography
                    align="center"
                    variant="montserrat412"
                    sx={{
                        color: '#666',
                        marginBottom: 0
                    }}>
                    ({step.bounds.min.toLocaleString()} - {step.bounds.max.toLocaleString()})
                </Typography>
            )}
        </FunnelStepContainer>
    );

}